import { LearningItem } from "./types";

export const numbers: LearningItem[] = [
  {
    id: "1",
    label: "1",
    word: "One",
    model: "/models/one.glb",
    audio: "/audio/1_one.mp3",
    color: "#ef4444", // red
    category: "number",
  },
  {
    id: "2",
    label: "2",
    word: "Two",
    model: "/models/two.glb",
    audio: "/audio/2_two.mp3",
    color: "#3b82f6", // blue
    category: "number",
  },
  {
    id: "3",
    label: "3",
    word: "Three",
    model: "/models/three.glb",
    audio: "/audio/3_three.mp3",
    color: "#10b981", // green
    category: "number",
  },
  {
    id: "4",
    label: "4",
    word: "Four",
    model: "/models/four.glb",
    audio: "/audio/4_four.mp3",
    color: "#f59e0b", // amber
    category: "number",
  },
  {
    id: "5",
    label: "5",
    word: "Five",
    model: "/models/five.glb",
    audio: "/audio/5_five.mp3",
    color: "#8b5cf6", // purple
    category: "number",
  },
  {
    id: "6",
    label: "6",
    word: "Six",
    model: "/models/six.glb",
    audio: "/audio/6_six.mp3",
    color: "#06b6d4", // cyan
    category: "number",
  },
];

